import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import FormUpdatePasswordClient from './FormUpdatePasswordClient';
import { isMobile } from 'react-device-detect';
import Snackbar from '../../../components/Snackbar';
import { validationUpdatePassword } from '../../../utils/validations';
import { auths } from '../../../configs/environments/firebase/firebaseApp';
// import { withFirebase } from 'react-redux-firebase';

const UpdatePasswordClient = props => {
  
    const [feedbackMessage, setFeedbackMessage] = useState({
      open: false,
      message: '',
      variant: 'info'
    });
  
    const handleCloseFeedbackMessage = () => {
      setFeedbackMessage({
        open: false,
        message: '',
        variant: 'info'
      });
    };
  
    const submitOldNewConfirmPassword = (
      values,
      { setSubmitting, setFieldError, resetForm }
    ) => {
      setSubmitting(false);
      const { currentPassword, newPassword, confirmPassword } = values;
      if (confirmPassword === newPassword) {
        const {
          profile: { email }
        } = props;
        auths
          .signInWithEmailAndPassword(email, currentPassword)
          .then(function(user) {
            auths
              .currentUser.updatePassword(newPassword)
              .then(function(res) {
                setFeedbackMessage({
                  open: true,
                  message: 'Contraseña actualizada exitosamente!',
                  variant: 'success'
                });
                resetForm();
              })
              .catch(function(err) {});
          })
          .catch(function(error) {
            if (error.code === 'auth/wrong-password') {
              setFieldError(
                'currentPassword',
                'La contraseña no es válida o el usuario no tiene una contraseña'
              );
            }
          });
      } else {
        setFieldError(
          'confirmPassword',
          'La nueva contraseña y su confirmación no coinciden'
        );
      }
    };
  
    return (
      <>
        <Formik
          initialValues={{
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
          }}
          validationSchema={validationUpdatePassword}
          onSubmit={submitOldNewConfirmPassword}
          render={props => (
            <FormUpdatePasswordClient
              handleSubmit={submitOldNewConfirmPassword}
              {...props}
            />
          )}
        />
  
        <Snackbar
          open={feedbackMessage.open}
          message={feedbackMessage.message}
          variant={feedbackMessage.variant}
          handleClose={handleCloseFeedbackMessage}
          vertical="top"
          horizontal="right"
          snackbarTop={isMobile ? '8px' : '80px'}
        />
      </>
    );
};

const mapStateToProps = state => ({
    profile: state.authClient
});
  
export default connect(mapStateToProps)(UpdatePasswordClient);